var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('router-view'),_vm._l((_vm.toastMessages),function(s,i){return _c('v-snackbar',{key:i,style:({ 'margin-bottom': _vm.calcMargin(i) }),attrs:{"value":_vm.showToast}},[_vm._v(_vm._s(s))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }